<button mat-button class='btn-configurations-test' (click)="btnActive='Easy'" [ngClass]="{'btn-active-green': btnActive==='Easy'}">Easy</button>
@if (merchantService.currentMerchant?.settings.isSDKJSActive) {
  <button mat-button class='btn-configurations-test' (click)="btnActive='Smart'" [ngClass]="{'btn-active-green': btnActive==='Smart'}">Smart</button>
}
@if (merchantService.currentMerchant?.settings.isSDKANDROIDActive || merchantService.currentMerchant.settings.isSDKIOSActive) {
  <button mat-button class='btn-configurations-test' (click)="btnActive='In-App'" [ngClass]="{'btn-active-green': btnActive==='In-App'}">In-App</button>
}
<div class="content-test">
  <div class="row-content-test">
    <h4>License Key API:
      @if (activeKey) {
        {{licenseServer ? licenseServer : ' - '}}
      }
      @if (!activeKey) {
        ******* ******* ******* *******
      }
    </h4>
    <div>
      @if (theme !=='dark-theme') {
        @if (!activeKey) {
          <mat-icon i18n-matTooltip='@@matTooltip-ShowApi-Key' matTooltip="Visualizza API-KEY " matTooltipPosition="above" (click)='activeKey =!activeKey' svgIcon='show' style="margin-right: 8px;">
          </mat-icon>
        } 
        @if (activeKey) {
          <mat-icon i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='activeKey =!activeKey' svgIcon='hide' style="margin-right: 8px;">
          </mat-icon>
        }
        <mat-icon i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseServer)'></mat-icon>
      }@else {
        @if (!activeKey) {
          <mat-icon class="tooltipDarkTheme" i18n-matTooltip='@@matTooltip-ShowApi-Key' matTooltip="Visualizza API-KEY " matTooltipPosition="above" (click)='activeKey =!activeKey' svgIcon='show' style="margin-right: 8px;">
          </mat-icon>
        } 
        @if (activeKey) {
          <mat-icon class="tooltipDarkTheme" i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='activeKey =!activeKey' svgIcon='hide' style="margin-right: 8px;">
          </mat-icon>
        }
        <mat-icon class="tooltipDarkTheme" i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseServer)'></mat-icon>
      }
      </div>
  </div>
  <!-- licenseWizard -->
  @if (btnActive==='Easy') {
    <div class="row-content-test">
      <h4>License Key Easy Checkout:
        @if (activeKeyEasy) {
          {{licenseWizard ? licenseWizard : ' - '}}
        }
        @if (!activeKeyEasy) {
          ******* ******* ******* *******
        }
      </h4>
      <div>
        @if (theme !=='dark-theme') {
          @if (!activeKeyEasy) {
            <mat-icon i18n-matTooltip='@@matTooltip-ShowApi-Key' matTooltip="Visualizza API-KEY " matTooltipPosition="above" (click)='activeKeyEasy =!activeKeyEasy' svgIcon='show'
            style="margin-right: 8px;"></mat-icon>
          }
          @if (activeKeyEasy) {
            <mat-icon i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='activeKeyEasy =!activeKeyEasy' svgIcon='hide' style="margin-right: 8px;"></mat-icon>
          }
          <mat-icon i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseWizard)'></mat-icon>
        }@else {
          @if (!activeKeyEasy) {
            <mat-icon class="tooltipDarkTheme" i18n-matTooltip='@@matTooltip-ShowApi-Key' matTooltip="Visualizza API-KEY " matTooltipPosition="above" (click)='activeKeyEasy =!activeKeyEasy' svgIcon='show'
            style="margin-right: 8px;"></mat-icon>
          }
          @if (activeKeyEasy) {
            <mat-icon class="tooltipDarkTheme" i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='activeKeyEasy =!activeKeyEasy' svgIcon='hide' style="margin-right: 8px;"></mat-icon>
          }
          <mat-icon class="tooltipDarkTheme" i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseWizard)'></mat-icon>          
        }
      </div>
    </div>
  }
  <!-- Smart -->
  @if (btnActive==='Smart') {
    <div class="row-content-test">
      <h4>License Key Smart Checkout:
        @if (activeKeyEasy) {
          {{licenseJS ? licenseJS : ' - '}}
        }
        @if (!activeKeyEasy) {
          ******* ******* ******* *******
        }
      </h4>
      <div>
      @if (theme !=='dark-theme') {
        @if (!activeKeyEasy) {
          <mat-icon (click)='activeKeyEasy =!activeKeyEasy' svgIcon='show'
          style="margin-right: 8px;"></mat-icon>
        }
        @if (activeKeyEasy) {
          <mat-icon i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='activeKeyEasy =!activeKeyEasy' svgIcon='hide' style="margin-right: 8px;"></mat-icon>
        }
        <mat-icon i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseJS)'></mat-icon>
      }@else {
        @if (!activeKeyEasy) {
          <mat-icon class="tooltipDarkTheme" (click)='activeKeyEasy =!activeKeyEasy' svgIcon='show'
          style="margin-right: 8px;"></mat-icon>
        }
        @if (activeKeyEasy) {
          <mat-icon class="tooltipDarkTheme" i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='activeKeyEasy =!activeKeyEasy' svgIcon='hide' style="margin-right: 8px;"></mat-icon>
        }
        <mat-icon class="tooltipDarkTheme" i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseJS)'></mat-icon>
      }
      </div>
    </div>
  }
  <!-- In-App -->
  @if (btnActive==='In-App' && merchantService.currentMerchant?.settings.isSDKIOSActive) {
    <div class="row-content-test">
      <h4>License Key In-App Checkout(SDK iOS):
        @if (activeKeyEasy) {
          {{licenseIos ? licenseIos : ' - '}}
        }
        @if (!activeKeyEasy) {
          ******* ******* ******* *******
        }
      </h4>
      <div>
      @if (theme !=='dark-theme') {
        @if (!activeKeyEasy) {
          <mat-icon i18n-matTooltip='@@matTooltip-ShowApi-Key' matTooltip="Visualizza API-KEY " matTooltipPosition="above" (click)='activeKeyEasy =!activeKeyEasy' svgIcon='show'
          style="margin-right: 8px;"></mat-icon>
        }
        @if (activeKeyEasy) {
          <mat-icon i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='activeKeyEasy =!activeKeyEasy' svgIcon='hide' style="margin-right: 8px;"></mat-icon>
        }
        <mat-icon i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseIos)'></mat-icon>
      }@else {
        @if (!activeKeyEasy) {
          <mat-icon class="tooltipDarkTheme" i18n-matTooltip='@@matTooltip-ShowApi-Key' matTooltip="Visualizza API-KEY " matTooltipPosition="above" (click)='activeKeyEasy =!activeKeyEasy' svgIcon='show'
          style="margin-right: 8px;"></mat-icon>
        }
        @if (activeKeyEasy) {
          <mat-icon class="tooltipDarkTheme" i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='activeKeyEasy =!activeKeyEasy' svgIcon='hide' style="margin-right: 8px;"></mat-icon>
        }
        <mat-icon class="tooltipDarkTheme" i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseIos)'></mat-icon>
      }
      </div>
    </div>
  }
  @if (btnActive==='In-App' && merchantService.currentMerchant?.settings.isSDKANDROIDActive) {
    <div class="row-content-test">
      <h4>License Key In-App Checkout(SDK Android):
        @if (activeKeyApp) {
          {{licenseAndroid ? licenseAndroid : ' - '}}
        }
        @if (!activeKeyApp) {
          ******* ******* ******* *******
        }
      </h4>
      <div>
        @if (theme !=='dark-theme') {
          @if (!activeKeyApp) {
            <mat-icon i18n-matTooltip='@@matTooltip-ShowApi-Key' matTooltip="Visualizza API-KEY " matTooltipPosition="above" (click)='activeKeyApp =!activeKeyApp' svgIcon='show'
            style="margin-right: 8px;"></mat-icon>
          }
          @if (activeKeyApp) {
            <mat-icon i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='activeKeyApp =!activeKeyApp' svgIcon='hide'style="margin-right: 8px;"></mat-icon>
          }
          <mat-icon i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseAndroid)'></mat-icon>
        }@else {
          @if (!activeKeyApp) {
            <mat-icon class="tooltipDarkTheme" i18n-matTooltip='@@matTooltip-ShowApi-Key' matTooltip="Visualizza API-KEY " matTooltipPosition="above" (click)='activeKeyApp =!activeKeyApp' svgIcon='show'
            style="margin-right: 8px;"></mat-icon>
          }
          @if (activeKeyApp) {
            <mat-icon class="tooltipDarkTheme" i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='activeKeyApp =!activeKeyApp' svgIcon='hide'style="margin-right: 8px;"></mat-icon>
          }
          <mat-icon class="tooltipDarkTheme" i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseAndroid)'></mat-icon>
        }
        </div>
    </div>
  }
</div>
